import React from 'react';

function Header() {
    return (
        <div>
            <h1>Key-Band</h1>
        </div>
    );
}

export default Header;
